import { combineReducers } from 'redux';
import { outboundCarrierReducer } from './OutboundCarrierReducer';
import { carrierReducer } from './CarrierReducer';

export default combineReducers({
  outbound: outboundCarrierReducer,
  carrier: carrierReducer,
});
